import { render, staticRenderFns } from "./aOwnerDetailRoomFee.vue?vue&type=template&id=3efae4aa&scoped=true"
import script from "./aOwnerDetailRoomFee.vue?vue&type=script&lang=js"
export * from "./aOwnerDetailRoomFee.vue?vue&type=script&lang=js"
import style0 from "./aOwnerDetailRoomFee.vue?vue&type=style&index=0&id=3efae4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efae4aa",
  null
  
)

export default component.exports